import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";

const healthHubUrl = GLOBAL_CONFIG.healthHubUrl;

const HealthHubTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={healthHubUrl}
                linkText={quickActionTilesMap[id].description}
                title={"The Health Hub"}
            />
        </QuickActionTile>
    );
};

HealthHubTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default HealthHubTile;
